import ROOM_ONE from "./query.gql";

export interface RoomVariables {
  roomId: string;
}

export interface RoomData {
  id: string;
  name: string;
  mode: "free" | "rented";
  group: {
    id: string;
    name: string;
  };
  building: {
    id: string;
    name: string;
  };
  mainLock?: LockData;
  subLock?: LockData;
  hub?: HubData;
  familyKeys?: FamilyKeyData[];
}

export interface LockData {
  id: string;
  serial: string;
}

export interface HubData {
  id: string;
  serial: string;
}

export type FamilyKeyData = {
  id: string;
  created_at: Date;
  updated_at: Date;
};

export interface RoomOneData {
  room: RoomData;
}

export { ROOM_ONE };
